import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/home//online_img.png';
import _imports_1 from '@/assets/images/right1.png';
import _imports_2 from '@/assets/images/bind_img.png';

const _withScopeId = n => (_pushScopeId("data-v-aafc721e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "card-box"
};
const _hoisted_2 = {
  key: 0,
  class: "online-card"
};
const _hoisted_3 = {
  class: "left"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "在线学堂", -1));

const _hoisted_5 = ["href"];

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "online-image"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));

const _hoisted_7 = {
  key: 0,
  class: "menu-list"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "left"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "menu-title"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-chakanquanbu arrow-icon"
}, null, -1));

const _hoisted_13 = {
  key: 0,
  class: "menu-card-203"
};
const _hoisted_14 = {
  class: "top"
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "教学平台", -1));

const _hoisted_16 = {
  class: "top-box"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = ["src"];

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));

const _hoisted_20 = ["onClick"];
const _hoisted_21 = ["src"];
const _hoisted_22 = {
  key: 1,
  class: "menu-card"
};
const _hoisted_23 = ["onClick"];
const _hoisted_24 = ["src"];
const _hoisted_25 = {
  class: "card-text"
};
const _hoisted_26 = {
  key: 2,
  class: "bind-box"
};

const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bind-tips-box"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "bind-img",
  src: _imports_2,
  alt: ""
}), /*#__PURE__*/_createElementVNode("div", {
  class: "bind-tips"
}, [/*#__PURE__*/_createElementVNode("div", null, "绑定智慧树账号"), /*#__PURE__*/_createElementVNode("div", null, "优享更多服务")])], -1));

const _hoisted_28 = /*#__PURE__*/_createTextVNode("去绑定 >");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");

  const _component_TipDialog = _resolveComponent("TipDialog");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [![1361, 203].includes($data.school_id) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("a", {
    href: $props.onlineLink,
    target: "_blank",
    class: "online-link"
  }, "进入 >", 8, _hoisted_5)]), _hoisted_6])) : _createCommentVNode("", true), $options.uuid() ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [$props.zhsRole == 3 || $props.zhsRole == 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.menuList, item => {
    return _openBlock(), _createElementBlock("li", {
      class: "menu-item",
      key: item.name,
      onClick: $event => $options.handleLink(item.jump_url)
    }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
      src: item.icon_url,
      alt: "",
      class: "menu-icon"
    }, null, 8, _hoisted_10), _createElementVNode("span", _hoisted_11, _toDisplayString(item.app_name), 1)]), _hoisted_12], 8, _hoisted_8);
  }), 128))])) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [[1361, 203].includes($data.school_id) ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.menuList.slice(0, 2), item => {
    return _openBlock(), _createElementBlock("div", {
      class: "item",
      key: item.name,
      onClick: $event => $options.handleLink(item.jump_url)
    }, [_createElementVNode("img", {
      src: item.icon_url,
      alt: ""
    }, null, 8, _hoisted_18), _createElementVNode("div", null, [_createTextVNode(_toDisplayString(item.app_name) + " ", 1), _hoisted_19])], 8, _hoisted_17);
  }), 128))])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.menuList.slice(2), item => {
    return _openBlock(), _createElementBlock("div", {
      class: "bottom-item",
      key: item.name,
      onClick: $event => $options.handleLink(item.jump_url)
    }, [_createElementVNode("img", {
      src: item.icon_url,
      alt: ""
    }, null, 8, _hoisted_21), _createElementVNode("div", null, _toDisplayString(item.app_name), 1)], 8, _hoisted_20);
  }), 128))])) : (_openBlock(), _createElementBlock("ul", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.menuList, item => {
    return _openBlock(), _createElementBlock("li", {
      class: "card-item",
      key: item.name,
      onClick: $event => $options.handleLink(item.jump_url)
    }, [_createElementVNode("img", {
      src: item.icon_url,
      class: "card-icon",
      alt: ""
    }, null, 8, _hoisted_24), _createElementVNode("span", _hoisted_25, _toDisplayString(item.app_name), 1)], 8, _hoisted_23);
  }), 128))]))], 64))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_26, [_hoisted_27, _createVNode(_component_el_button, {
    class: "bind-btn",
    type: "primary",
    round: "",
    onClick: $options.goToBind
  }, {
    default: _withCtx(() => [_hoisted_28]),
    _: 1
  }, 8, ["onClick"])]))]), _createVNode(_component_TipDialog, {
    show: $data.showDialog,
    "onUpdate:show": _cache[0] || (_cache[0] = $event => $data.showDialog = $event)
  }, null, 8, ["show"])], 64);
}